import React from 'react';
import { useLang } from '../../context/LanguageContext';
import { useSiteConfig } from '../../context/SiteConfigContext';

const Steps = () => {
  const { lang } = useLang();
  const { config } = useSiteConfig();
  const s = config?.steps?.[lang];
  if (!s) return null;

  return (
    <section id="steps" className="bg-[#f5f1e8] text-[#0e2a24]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-24">
        <p className="text-[11px] tracking-[0.25em] uppercase text-[#0e2a24]/50">{s.overline}</p>
        <h2 className="mt-4 font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight max-w-3xl">{s.title}</h2>
        <p className="mt-4 text-[15px] text-[#0e2a24]/70 max-w-2xl">{s.lead}</p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
          {(s.items || []).map((it, idx) => (
            <div key={idx} className="border-t border-[#0e2a24]/15 pt-6">
              <p className="font-mono text-[11px] text-[#0e2a24]/50">{String(idx + 1).padStart(2, '0')}</p>
              <h3 className="mt-2 font-serif text-xl tracking-tight">{it.title}</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-[#0e2a24]/70">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Steps;
